<template>
  <div class="history-search-bar">
    <el-form :model="searchForm" label-position="top">
      <el-row :gutter="20">
        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('SpecialAccountManagement.userAccount')">
            <el-select 
              v-model="searchForm.userId" 
              style="width: 100%"
              :loading="usersLoading" 
              filterable 
              clearable 
              remote 
              :remote-method="loadUsersList"
              :placeholder="$t('SpecialAccountManagement.userAccountPlaceholder')"
            >
              <el-option 
                v-for="user in usersList" 
                :key="user.id" 
                :label="user.email || user.name || user.id" 
                :value="user.id" 
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('SpecialAccountManagement.enableStatus')">
            <el-select v-model="searchForm.enable" filterable
                      :placeholder="$t('SpecialAccountManagement.enableStatusPlaceholder')" :clearable="true"
                      class="custom-tree-select-width"
                      label-position="top">
              <el-option :label="$t('SpecialAccountManagement.enable')" :value="1"/>
              <el-option :label="$t('SpecialAccountManagement.disable')" :value="0"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" :sm="12" :md="7" :lg="4">
          <el-form-item label=" ">
            <el-button class="button-background-color" @click="handleSearch">
              {{ $t('SpecialAccountManagement.search') }}
            </el-button>
            <el-button @click="handleReset" class="custom-reset-button">
              {{ $t('SpecialAccountManagement.reset') }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import dialogMixin from "@/mixins/dialogMixin";
import { getUsersSimple } from '@/api/api';
import { ElMessage } from 'element-plus';

export default {
  data() {
    return {
      searchForm: {
        userId: '',
        enable: ''
      },
      usersList: [], // 账号列表数据
      usersLoading: false // 账号数据加载状态
    };
  },
  mixins: [dialogMixin],
  
  mounted() {
    // 组件挂载时加载账号列表
    this.loadUsersList();
  },
  
  methods: {
    // 加载用户列表，支持搜索
    async loadUsersList(query = '') {
      this.usersLoading = true;
      try {
        const res = await getUsersSimple();
        
        if (res && res.code === 0 && Array.isArray(res.data)) {
          if (query) {
            // 如果有搜索词，在本地过滤数据
            this.usersList = res.data.filter(user => 
              // 在email、name或id中搜索
              (user.email && user.email.toLowerCase().includes(query.toLowerCase())) ||
              (user.name && user.name.toLowerCase().includes(query.toLowerCase())) ||
              (user.id && user.id.toString().includes(query))
            );
          } else {
            // 如果没有搜索词，显示全部数据
            this.usersList = res.data;
          }
        } else {
          ElMessage.error(this.$t('SpecialAccountManagement.loadUsersFailed'));
          this.usersList = [];
        }
      } catch (error) {
        console.error('加载用户列表失败:', error);
        ElMessage.error(this.$t('SpecialAccountManagement.loadUsersFailed'));
        this.usersList = [];
      } finally {
        this.usersLoading = false;
      }
    },
    
    // 搜索处理
    handleSearch() {
      // 构建符合API要求的搜索参数对象
      const searchCondition = {};

      // 用户账号（精确匹配）
      if (this.searchForm.userId && this.searchForm.userId !== '') {
        searchCondition["user-id-eq"] = this.searchForm.userId;
      }

      // 启用状态（精确匹配）
      if (this.searchForm.enable !== '') {
        searchCondition["enable-eq"] = this.searchForm.enable;
      }



      // 发送搜索请求并将搜索条件传递给父组件
      this.$emit('search', searchCondition);
    },
    
    // 重置表单
    handleReset() {
      this.searchForm = {
        userId: '',
        enable: ''
      };
    }
  }
};
</script>

<style scoped>
.history-search-bar {
  background: setBackgroundColor();

  .el-form-item {
    margin-bottom: 10px;
  }
}

.button-background-color {
  background: setButtonBackgroundColor();
  color: inButtonTextColor();
  border: setButtonBorderColor();
  margin: 0; 
}

.custom-reset-button {
  margin-left: 10px;
}

:deep(.custom-tree-select-width) {
  width: 100%;
}

:deep(.date-picker-width) {
  width: 100%;
}

:deep(.date-picker-popper) {
  left: 0 !important;
  right: auto !important;
  transform: none !important;
}
</style>